var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { PATCH_COPY_TYPE } from './constants';
export var getInputPatchId = function (patchwork, selectedPatchId) {
    if (selectedPatchId === void 0) { selectedPatchId = null; }
    var result = [];
    if (!selectedPatchId) {
        return result;
    }
    var selectedPatchEdges = patchwork &&
        patchwork.edges &&
        patchwork.edges.filter(function (edge) { return edge.to_patch === selectedPatchId; });
    if (selectedPatchEdges && selectedPatchEdges.length > 0 && patchwork) {
        selectedPatchEdges.forEach(function (edge) {
            var _a;
            var previousPatch = patchwork.patches.find(function (patch) { return patch.id === edge.from_patch; });
            if (previousPatch) {
                if (previousPatch.type === 'dataset' ||
                    (previousPatch.type === 'list' &&
                        previousPatch.list === 'from_dataset')) {
                    result.push({
                        id: edge.to_patch,
                        dataset: previousPatch.dataset,
                        type: 'dataset',
                    });
                    return;
                }
                if (previousPatch.outputs.some(function (output) { return output.type === 'json'; })) {
                    previousPatch.outputs.forEach(function (output) {
                        if (output.type === 'json') {
                            result.push.apply(result, patchwork.patches
                                .map(function (p) {
                                return ((p.type === 'dataset' ||
                                    (p.type === 'list' && p.list === 'from_dataset')) && {
                                    id: edge.to_patch,
                                    dataset: p.dataset,
                                    dataKey: output.name.replace('out:', ''),
                                    type: 'dataset',
                                }) ||
                                    null;
                            })
                                .filter(function (p) { return p !== null; }));
                        }
                    });
                    return;
                }
            }
            if (edge.to_patch === selectedPatchId) {
                var selectedPatch = patchwork.patches.find(function (patch) { return patch.id === selectedPatchId; });
                var manualInputs = ((_a = selectedPatch === null || selectedPatch === void 0 ? void 0 : selectedPatch.inputs) === null || _a === void 0 ? void 0 : _a.filter(function (input) { return !['event', 'object'].includes(input.type); })) || [];
                if (manualInputs.length > 0) {
                    result.push({
                        id: selectedPatch.id,
                        type: 'manual',
                        keys: manualInputs,
                    });
                }
            }
        });
    }
    return result;
};
export var mapDatasetRowValues = function (datasets) {
    if (datasets === void 0) { datasets = {}; }
    var options = [];
    Object.keys(datasets).forEach(function (dataset) {
        options.push({
            dataset_id: dataset,
            label: (datasets[dataset].info && datasets[dataset].info.name) || 'Dataset',
            options: (datasets[dataset].objects || datasets[dataset]).map(function (row) { return ({
                display: row,
                value: { dataset: dataset, item_id: row.id },
                label: row.id,
            }); }),
        });
    });
    return options;
};
export var appendOutToName = function (name) {
    if (name === void 0) { name = ''; }
    return name.includes('out:') ? name : "out:".concat(name);
};
export var cleanPatchOutputs = function (patch) {
    if (patch === void 0) { patch = { outputs: [] }; }
    return (__assign(__assign({}, patch), { outputs: (patch.outputs || []).map(function (o) { return (__assign(__assign({}, o), { name: appendOutToName(o.name) })); }) }));
};
export var createUniquePatchDiff = function (patch) {
    if (patch === void 0) { patch = {}; }
    return "".concat(patch.id, "-").concat(patch.name, "-").concat(patch.type, "-").concat(patch.navigation, "-").concat(patch.entrypoint);
};
/* getConnectedLogic returns:
  + patches >> an array of logic patches connected to the provided patch
   + endEdges >> an array of edges at the end of every logic chain
   + endPatches >> an array of patches at the end of every logic chain */
export var getConnectedLogic = function (_a) {
    var _b = _a.patches, patches = _b === void 0 ? [] : _b, _c = _a.edges, edges = _c === void 0 ? [] : _c, _d = _a.patch, patch = _d === void 0 ? null : _d, _e = _a.connected, connected = _e === void 0 ? { patches: [], endEdges: [], middleEdges: [], endPatches: [] } : _e, _f = _a.iterationCount, iterationCount = _f === void 0 ? 0 : _f;
    if (iterationCount > edges.length + 1) {
        return connected;
    }
    // no patch passed, stop
    if (!patch) {
        return connected;
    }
    // edges connected to this patch
    var toEdges = edges.filter(function (edge) { return edge.from_patch === patch.id; });
    // no edges connected, this must be the end
    if (toEdges.length === 0) {
        // only append patch if it is not already in the array
        var existingPatch = connected.endPatches.find(function (p) { return p.id === patch.id; });
        if (!existingPatch) {
            connected.endPatches.push(__assign({}, patch));
        }
        return connected;
    }
    var _loop_1 = function (toEdge) {
        // find the patch connected to this edge
        var toPatch = patches.find(function (p) { return p.id === toEdge.to_patch; });
        // no connected patch, skip
        if (!toPatch) {
            return "continue";
        }
        if (toPatch.type !== 'logic' || toPatch.logic === 'async_logic') {
            // connected patch is not logic or async_logic, this is the end of the group
            connected.endEdges.push(__assign({}, toEdge));
            // only append patch if it is not already in the array
            var existingPatch = connected.endPatches.find(function (p) { return p.id === patch.id; });
            if (!existingPatch) {
                connected.endPatches.push(__assign({}, patch));
            }
            return "continue";
        }
        else {
            // connected patch is logic, push and continue
            connected.middleEdges.push(__assign({}, toEdge));
        }
        // run again
        connected = getConnectedLogic({
            patches: patches,
            edges: edges,
            patch: toPatch,
            connected: __assign(__assign({}, connected), { patches: __spreadArray(__spreadArray([], connected.patches, true), [toPatch], false) }),
            iterationCount: iterationCount + 1,
        });
    };
    for (var _i = 0, toEdges_1 = toEdges; _i < toEdges_1.length; _i++) {
        var toEdge = toEdges_1[_i];
        _loop_1(toEdge);
    }
    return connected;
};
export var cleanArgName = function (arg) {
    if (arg === void 0) { arg = ''; }
    var fromArgs = arg.split(':');
    return fromArgs.length > 2 ? "".concat(fromArgs[1], ":").concat(fromArgs[2]) : arg;
};
export var getPatchIdFromName = function (arg) {
    if (arg === void 0) { arg = ''; }
    var fromArgs = arg.split(':');
    if (fromArgs.length > 2) {
        return fromArgs[0];
    }
    return null;
};
export var getInComingEdgesFromPatchId = function (patchId, patchwork) {
    var _a, _b;
    if (patchId && Array.isArray((_a = patchwork === null || patchwork === void 0 ? void 0 : patchwork.edges) !== null && _a !== void 0 ? _a : null))
        return (_b = patchwork.edges) === null || _b === void 0 ? void 0 : _b.filter(function (edge) { return (edge === null || edge === void 0 ? void 0 : edge.to_patch) === patchId; });
    return [];
};
export var getOutGoingEdgesFromPatchId = function (patchId, patchwork) {
    var _a, _b;
    if (patchId && Array.isArray((_a = patchwork === null || patchwork === void 0 ? void 0 : patchwork.edges) !== null && _a !== void 0 ? _a : null))
        return (_b = patchwork.edges) === null || _b === void 0 ? void 0 : _b.filter(function (edge) { return (edge === null || edge === void 0 ? void 0 : edge.from_patch) === patchId; });
    return [];
};
export var cleanEdgeArgName = function (edge) {
    if (edge === void 0) { edge = {}; }
    return (__assign(__assign({}, edge), { from_arg: cleanArgName(edge.from_arg), to_arg: cleanArgName(edge.to_arg) }));
};
export function propertiesToArray(obj) {
    if (obj === void 0) { obj = {}; }
    var isObject = function (val) { return typeof val === 'object' && !Array.isArray(val); };
    var addDelimiter = function (a, b) { return (a ? "".concat(a, ".").concat(b) : b); };
    var paths = function (object, head) {
        if (object === void 0) { object = {}; }
        if (head === void 0) { head = ''; }
        return Object.entries(object).reduce(function (product, _a) {
            var key = _a[0], value = _a[1];
            var fullPath = addDelimiter(head, key);
            return isObject(value)
                ? product.concat(paths(value, fullPath))
                : product.concat({
                    id: fullPath,
                    type: typeof value,
                });
        }, []);
    };
    return paths(obj);
}
export function flattenArray(data) {
    if (data === void 0) { data = []; }
    var initialValue = [];
    // call reduce on our data
    return data.reduce(function (total, value) {
        // if the value is an array then recursively call reduce
        // if the value is not an array then just concat our value
        return total.concat(Array.isArray(value) ? flattenArray(value) : value);
    }, initialValue);
}
export var mergeCustomEvents = function (views, selectedViewIds) {
    var datasetOutputs = [];
    views.forEach(function (view) {
        if (selectedViewIds.includes(view.id) && view.outputs.length) {
            var ids_1 = new Set(datasetOutputs.map(function (op) { return op.name; }));
            datasetOutputs = __spreadArray(__spreadArray([], datasetOutputs, true), view.outputs.filter(function (op) { return !ids_1.has(op.name); }), true);
        }
    });
    return datasetOutputs;
};
export var getPatchCopyAvailability = function () {
    var _a;
    return !!((_a = Object.values(PATCH_COPY_TYPE)) === null || _a === void 0 ? void 0 : _a.map(function (key) {
        var _a, _b, _c;
        var item = localStorage.getItem(key);
        if (item) {
            return (_c = (_b = (_a = JSON.parse(item)) === null || _a === void 0 ? void 0 : _a.patches) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        }
        return 0;
    }).reduce(function (prev, curr) { return prev + curr; }, 0));
};
var onlyKeepThisCopyType = function (type) {
    Object.values(PATCH_COPY_TYPE)
        .filter(function (value) { return value !== type; })
        .forEach(function (key) {
        localStorage.removeItem(key);
    });
};
export var copyPatches = function (appId, patchwork, id, patchType) {
    var _a, _b, _c, _d, _e;
    var isPatchExist = ((_a = patchwork === null || patchwork === void 0 ? void 0 : patchwork.patches) === null || _a === void 0 ? void 0 : _a.find(function (l) { return l.id === id; })) || null;
    var edges = [];
    var patches = [];
    if ((isPatchExist === null || isPatchExist === void 0 ? void 0 : isPatchExist.logic) === 'input')
        return false;
    if (isPatchExist && patchType === 'logic_group') {
        var filterLogicGroup = Object.fromEntries(Object.entries(patchwork === null || patchwork === void 0 ? void 0 : patchwork.logicGroups).filter(function (_a) {
            var key = _a[0];
            return key === id;
        }));
        var logicGroupItems = Object.values(filterLogicGroup);
        (_c = (_b = logicGroupItems[0]) === null || _b === void 0 ? void 0 : _b.patches) === null || _c === void 0 ? void 0 : _c.forEach(function (patchIds) {
            patches.push("".concat(patchIds.id));
        });
        var filteredEdges = (_e = (_d = logicGroupItems[0]) === null || _d === void 0 ? void 0 : _d.edges) === null || _e === void 0 ? void 0 : _e.filter(function (edgeId) {
            return (patches.indexOf(edgeId.from_patch) !== -1 &&
                patches.indexOf(edgeId.to_patch) !== -1);
        });
        filteredEdges.forEach(function (edgeIds) {
            edges.push("".concat(edgeIds.id));
        });
        // get the unique patches & edges
        var uniquePatches = patches.filter(function (patch, index) {
            return patches.indexOf(patch) === index;
        });
        var uniqueEdges = edges.filter(function (edge, index) {
            return edges.indexOf(edge) === index;
        });
        var copiedLogicGroupBlock = {
            appId: appId,
            patchworkId: patchwork.id,
            patches: uniquePatches,
            edges: uniqueEdges,
            type: patchType,
        };
        onlyKeepThisCopyType(PATCH_COPY_TYPE.POLY);
        localStorage.setItem(PATCH_COPY_TYPE.POLY, JSON.stringify(copiedLogicGroupBlock));
        return true;
    }
    else if (isPatchExist) {
        patches.push(id);
        var copiedPatch = {
            appId: appId,
            patchworkId: patchwork.id,
            patches: patches,
            type: (isPatchExist === null || isPatchExist === void 0 ? void 0 : isPatchExist.logic) === 'custom_logic'
                ? 'custom_logic'
                : isPatchExist === null || isPatchExist === void 0 ? void 0 : isPatchExist.type,
        };
        onlyKeepThisCopyType(PATCH_COPY_TYPE.MONO);
        localStorage.setItem(PATCH_COPY_TYPE.MONO, JSON.stringify(copiedPatch));
        localStorage.removeItem(PATCH_COPY_TYPE.CONTEXT);
        return true;
    }
    else {
        onlyKeepThisCopyType();
        return false;
    }
};
export var getLogicGroupPatches = function (appId, patchwork, id, patchType) {
    var _a, _b, _c, _d, _e;
    var isPatchExist = ((_a = patchwork === null || patchwork === void 0 ? void 0 : patchwork.patches) === null || _a === void 0 ? void 0 : _a.find(function (l) { return l.id === id; })) || null;
    var edges = [];
    var patches = [];
    if ((isPatchExist === null || isPatchExist === void 0 ? void 0 : isPatchExist.logic) === 'input')
        return { edges: edges, patches: patches };
    if (isPatchExist && patchType === 'logic_group') {
        var filterLogicGroup = Object.fromEntries(Object.entries(patchwork === null || patchwork === void 0 ? void 0 : patchwork.logicGroups).filter(function (_a) {
            var key = _a[0];
            return key === id;
        }));
        var logicGroupItems = Object.values(filterLogicGroup);
        (_c = (_b = logicGroupItems[0]) === null || _b === void 0 ? void 0 : _b.patches) === null || _c === void 0 ? void 0 : _c.forEach(function (patchIds) {
            patches.push("".concat(patchIds.id));
        });
        var filteredEdges = (_e = (_d = logicGroupItems[0]) === null || _d === void 0 ? void 0 : _d.edges) === null || _e === void 0 ? void 0 : _e.filter(function (edgeId) {
            return (patches.indexOf(edgeId.from_patch) !== -1 &&
                patches.indexOf(edgeId.to_patch) !== -1);
        });
        filteredEdges.forEach(function (edgeIds) {
            edges.push("".concat(edgeIds.id));
        });
        // get the unique patches & edges
        var uniquePatches = patches.filter(function (patch, index) {
            return patches.indexOf(patch) === index;
        });
        var uniqueEdges = edges.filter(function (edge, index) {
            return edges.indexOf(edge) === index;
        });
        return { edges: uniqueEdges, patches: uniquePatches };
    }
    else if (isPatchExist) {
        patches.push(id);
        return { edges: edges, patches: patches };
    }
    else {
        return { edges: edges, patches: patches };
    }
};
export var copyPatchSelection = function (appId, firstPatch, patchIds, groupIds, patchwork, customLogic, validCrossAppCopy) {
    if (validCrossAppCopy === void 0) { validCrossAppCopy = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var finalPatches_1, finalEdges_1, edgesToCopy_1, _a, edges, patches;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(firstPatch === null || firstPatch === void 0 ? void 0 : firstPatch.id)) return [3 /*break*/, 2];
                    finalPatches_1 = patchIds.map(function (patch) { return (patch.id ? patch.id : patch); });
                    finalEdges_1 = [];
                    if ((patchIds === null || patchIds === void 0 ? void 0 : patchIds.length) && appId && patchwork) {
                        edgesToCopy_1 = [];
                        ((_c = (_b = patchwork === null || patchwork === void 0 ? void 0 : patchwork.edges) === null || _b === void 0 ? void 0 : _b.filter(function (edge) {
                            return (patchIds === null || patchIds === void 0 ? void 0 : patchIds.includes(edge.from_patch)) &&
                                (patchIds === null || patchIds === void 0 ? void 0 : patchIds.includes(edge.to_patch));
                        })) !== null && _c !== void 0 ? _c : []).forEach(function (edge) {
                            edgesToCopy_1.push(edge === null || edge === void 0 ? void 0 : edge.id);
                        });
                        finalEdges_1 = __spreadArray([], edgesToCopy_1, true);
                    }
                    if (groupIds.length) {
                        groupIds.forEach(function (id) {
                            var _a = getLogicGroupPatches(appId, patchwork, id, 'logic_group'), edges = _a.edges, patches = _a.patches;
                            finalPatches_1 = __spreadArray(__spreadArray([], finalPatches_1, true), patches, true);
                            finalEdges_1 = __spreadArray(__spreadArray([], finalEdges_1, true), edges, true);
                        });
                    }
                    if ((firstPatch === null || firstPatch === void 0 ? void 0 : firstPatch.patchType) === 'logic_group') {
                        _a = getLogicGroupPatches(appId, patchwork, firstPatch === null || firstPatch === void 0 ? void 0 : firstPatch.id, 'logic_group'), edges = _a.edges, patches = _a.patches;
                        finalPatches_1 = __spreadArray(__spreadArray([], patches, true), finalPatches_1, true);
                        finalEdges_1 = __spreadArray(__spreadArray([], finalEdges_1, true), edges, true);
                    }
                    //remove duplicates
                    finalPatches_1 = finalPatches_1.filter(function (item, index) { return finalPatches_1.indexOf(item) === index; });
                    finalEdges_1 = finalEdges_1.filter(function (item, index) { return finalEdges_1.indexOf(item) === index; });
                    return [4 /*yield*/, localStorage.setItem(PATCH_COPY_TYPE.CONTEXT, JSON.stringify({
                            appId: appId,
                            patchworkId: patchwork.id,
                            patches: finalPatches_1,
                            edges: finalEdges_1,
                            customLogic: customLogic,
                            validCrossAppCopy: validCrossAppCopy,
                        }))];
                case 1:
                    _d.sent();
                    localStorage.removeItem(PATCH_COPY_TYPE.MONO);
                    return [2 /*return*/, true];
                case 2:
                    localStorage.removeItem(PATCH_COPY_TYPE.CONTEXT);
                    return [2 /*return*/, false];
            }
        });
    });
};
var connectedEdges = function (count, id, fromLink, edges) {
    var connectedEdgesFilter = edges.filter(function (value) { return value.from_patch === id && value.from_patch !== value.to_patch; });
    if (connectedEdgesFilter.length > 0) {
        var connectedEdgesToPatch_1 = connectedEdgesFilter.map(function (item) { return item.to_patch; });
        var removeDuplicatesOfConnectedEdges = connectedEdgesToPatch_1.filter(function (edges, index) { return connectedEdgesToPatch_1.indexOf(edges) === index; });
        count++;
        return isRemoveLoops(count, removeDuplicatesOfConnectedEdges, fromLink, edges);
    }
    else {
        return true;
    }
};
var isRemoveLoops = function (count, filterEdges, fromLink, edges) {
    var isConnected = true;
    filterEdges.forEach(function (id) {
        if (id === fromLink) {
            isConnected = false;
        }
        else {
            if (count < edges.length && isConnected) {
                isConnected = connectedEdges(count, id, fromLink, edges);
            }
            else {
                isConnected = false;
            }
        }
        return isConnected;
    });
    return isConnected;
};
export var findConnectedEdges = function (targetPatch, patchwork, source, target) {
    var edges = patchwork.edges;
    var fromLink = source.parent.id;
    var toLink = target.parent.id;
    var count = 0;
    var filterEdges = edges.filter(function (val) { return val.from_patch === toLink && val.from_patch !== val.to_patch; });
    var getFromPatches = filterEdges.map(function (item) { return item.to_patch; });
    var removeDuplicatesOfFromPatches = getFromPatches.filter(function (edges, index) { return getFromPatches.indexOf(edges) === index; });
    var isFromToSame = target.parent.id === source.parent.id;
    var sourcePort = source.patchPort;
    if (sourcePort && sourcePort.name.includes('in:')) {
        return false;
    }
    var targetPort = target.patchPort;
    if (targetPort && targetPort.name.includes('out:')) {
        return false;
    }
    if (isFromToSame) {
        return false;
    }
    if (filterEdges.length > 0) {
        return isRemoveLoops(count, removeDuplicatesOfFromPatches, fromLink, edges);
    }
    else {
        return true;
    }
};
